import { useState } from "react";
interface ForgotPasswordProps {
    onForgotPassword: (userName: string) => void;
}

const ForgotPassword = (props: ForgotPasswordProps) => {
    const [emailId, setEmailId] = useState<string>("");

    const onSubmit = () => {
        props.onForgotPassword(emailId);
    };
    return (
        <div className="container-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="quform-element form-group">
                        <div className="quform-input">
                            <input type="text" className="form-control" name="username" placeholder="Please Enter your UserName / Email Id" autoComplete="off" onKeyUp={e => setEmailId((e.target as HTMLInputElement).value)}></input>
                        </div>
                    </div>
                </div>
                <button className="butn primary mt-4" type="submit" onClick={onSubmit} disabled={emailId === ""}><span>Submit</span></button>
            </div>
        </div>
    );
};
export default ForgotPassword;